module.exports = __webpack_public_path__ + "img/light-magnifying-glass.a531fdb9.svg";